import React from 'react';

// Card shimmer effect for repositories
export const CardShimmer = () => (
  <div className="bg-white rounded-lg shadow-md border border-[#C0ACF3] p-4 animate-pulse">
    <div className="flex items-center justify-between mb-3">
      <div className="h-4 bg-gray-200 rounded w-3/4"></div>
    </div>
    <div className="space-y-3">
      <div className="h-3 bg-gray-200 rounded w-1/2"></div>
      <div className="flex space-x-2">
        <div className="h-8 bg-gray-200 rounded w-16"></div>
        <div className="h-8 bg-gray-200 rounded w-16"></div>
      </div>
      <div className='flex gap-2 items-end justify-between'>
        <div className="h-3 bg-gray-200 rounded w-2/4"></div>
        <div className="h-3 bg-gray-200 rounded w-1/4"></div>
      </div>
    </div>
  </div>
);

// Table row shimmer effect for findings
export const TableRowShimmer = () => (
  <tr className="animate-pulse">
    <td className="p-3">
      <div className="flex items-center space-x-2">
        <div className="w-4 h-4 bg-gray-200 rounded-full"></div>
        <div className="h-6 bg-gray-200 rounded w-20"></div>
      </div>
    </td>
    <td className="p-3">
      <div className="h-4 bg-gray-200 rounded w-28"></div>
    </td>
    <td className="p-3">
      <div className="h-4 bg-gray-200 rounded w-14"></div>
    </td>
    <td className="p-3">
      <div className="h-4 bg-gray-200 rounded w-24"></div>
    </td>
    <td className="p-3 text-right">
      <div className="flex justify-end gap-2">
        <div className="h-8 w-10 rounded bg-gray-200"></div>
        <div className="h-8 w-14 rounded bg-gray-200"></div>
        <div className="h-8 w-10 rounded bg-gray-200"></div>
      </div>
    </td>
  </tr>
);

// Multiple card shimmers
export const CardShimmerGrid = ({ count = 8 }) => (
  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3 sm:gap-4 md:gap-5">
    {Array.from({ length: count }).map((_, index) => (
      <CardShimmer key={index} />
    ))}
  </div>
);

// Multiple table row shimmers
export const TableShimmer = ({ count = 5 }) => (
  <div className="overflow-x-auto">
    <table className="w-full text-sm">
      <thead>
        <tr className="border-b border-[#C0ACF3]">
          <th className="text-left p-3 text-[#000000] font-medium">Status</th>
          <th className="text-left p-3 text-[#000000] font-medium">Scan ID</th>
          <th className="text-left p-3 text-[#000000] font-medium">Developer</th>
          <th className="text-left p-3 text-[#000000] font-medium">Source</th>
          <th className="text-left p-3 text-[#000000] font-medium">File</th>
          <th className="text-left p-3 text-[#000000] font-medium">Raw Result</th>
          <th className="text-left p-3 text-[#000000] font-medium">Blast Radius</th>
          <th className="text-left p-3 text-[#000000] font-medium">Actions</th>
        </tr>
      </thead>
      <tbody>
        {Array.from({ length: count }).map((_, index) => (
          <TableRowShimmer key={index} />
        ))}
      </tbody>
    </table>
  </div>
);
